import axios from 'axios';

// axios.defaults.headers.common['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['authKey'] = sessionStorage.getItem('authKey'); //relevant only for candidates, admins and users does not have authKey, they are validated either by windows authentication or by FIM

const axiosInstance = axios.create({
    baseURL: window.location.hostname === 'localhost' ? 'http://apps/ReliabilityCheck/' : process.env.PUBLIC_URL //'http://appqa.mod.int/RCWin/' //'http://apps/ReliabilityCheck/' //'http://RcWin/'
});

//configure pipeline
axiosInstance.interceptors.request.use(request => {
    request.headers["Access-Control-Allow-Origin"] = '*';
    request.headers["Content-Type"] = 'application/json';
    request.headers["authKey"] = sessionStorage.getItem('authKey');
    //request.headers.authKey = sessionStorage.getItem('authKey');
    return request
}, error =>{
    console.log(error);
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(response => {
    //handle server error
    console.log('AJAX Error:');
    if(response.status == 500){
        console.log(response);
        alert('אירעה שגיאה במערכת');
    }

    //handle redirect to fim login after session is over
    if(response.status > 299 && response.status < 400){
        document.getElementById('root').innerHTML(response.data);
    }

    return response;
});

export default axiosInstance;